import { atom } from 'jotai'

export type PageAnalyticsData = Record<string, string | undefined>

export const createPageAnalyticsAtom = (initial: PageAnalyticsData = {}) =>
  atom<PageAnalyticsData>(initial)

export const dashboardAnalyticsAtom = createPageAnalyticsAtom()
